
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && Flits.Metafields.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  }
  
   // WISHLIST
 if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
   Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
 }
 Flits(document).on('Flits:wishlistButton:Loaded', function(event){
   if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product') {
     let collectionBtn = Flits('.flits-wishlist-colection');
     parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
       Flits(collectionBtn).show(),
       Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
   }
 });
  Flits(document).on('click', '.flits-popup-order-item-col #all-item', function(event){
    if (Flits(this).is(':checked')) {
      Flits('.flits-popup-order-item-col input[type="checkbox"]').prop('checked', true);
    } else {
      Flits('.flits-popup-order-item-col input[type="checkbox"]').prop('checked', false);
    }
  });
  Flits(document).on('click', '.flits-popup-order-item-col input[type="checkbox"]', function(event){
    if (Flits(this).is(':checked')) {
      //       Flits('.flits-popup-order-item-col #all-item').prop('checked', true);
    } else {
      Flits('.flits-popup-order-item-col #all-item').prop('checked', false);
    }
  });
  Flits(document).on('click', '.flits-custom-contact-btn', function(event){
    Flits('#flits-custom-contact-popup').addClass('active');
  });
  Flits(document).on('click', '#flits-custom-contact-popup .close-modal', function(event){
    Flits('#flits-custom-contact-popup').removeClass('active');
  });
  window.flitswishlistResponse = {};
  Flits(document).on('Flits:Wishlist:AjaxSuccessful',function(event){
    var data = event.detail;
    window.flitswishlistResponse = data.resp;
  });
  Flits(document).on('Flits:getShopifyProductData:complete',function(event){
    var data = event.detail;
    if(Flits(data.item).find('.flits-product-card').hasClass('flits-wishlist-card')){
      if(!data.status){
        console.log("Wishlist Data Added..!")
        var itemDom = data.item;	
        var product = flitsGetProductDetailsFromWishlistResponse(data.handle);
        let image = "https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
        product.product_image != null && (image = product.product_image);
        let extidx = image.lastIndexOf(".");
        let extension = image.substr(extidx);
        (image = image.replace(extension, "_200x_crop_center" + extension)), Flits(itemDom).find(".flits-product-image img").attr("src", image);
        let imgWidth = Flits(itemDom).find(".flits-product-image img").width();
        let imgHeight = Flits(itemDom).find(".flits-product-image img").height();
        imgWidth > imgHeight;
        Flits(itemDom).find(".flits-floating-label label").html(product.product_title );
        Flits(itemDom).find(".flits-product-price").html(Flits.formatMoney(Math.abs(0 * 100), Flits.money_format));
        Flits(itemDom).find(".flits-product-price").css({
          visibility:"hidden"
        });
        Flits(itemDom).find(".flits-floating-label").addClass("flits-without-select"),
          Flits(itemDom).find(".flits-floating-label.flits-without-select").attr("data-tippy-content", product.product_title);
        Flits(itemDom).find(".flits-floating-label .flits-variant-select").hide();
        Flits(itemDom).find(".flits-floating-label label").attr("data-tippy-content", product.product_title );
        Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-id", product.product_id );
        Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-title", product.product_title);
        Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-handle", product.product_handle );
        Flits(itemDom).find(".flits-add-to-cart").attr("data-remove", product.product_id);
        let sold_out_text = Flits(itemDom).find(".flits-add-to-cart").attr("data-flits-sold-text");
        Flits(itemDom).find(".flits-add-to-cart").addClass("flits-btn-danger");
        Flits(itemDom).find(".flits-add-to-cart").attr("disabled", !0);
        Flits(itemDom).find(".flits-add-to-cart").text(sold_out_text);
        Flits(itemDom).find(".flits-product-quantity").addClass("flits-disabled");
      }
    }
    else if(Flits(data.item).find('.flits-product-card').hasClass('flits-recently-view-card')){    
      if(!data.status){
        Flits(data.item).css("display","none")
      }
    }
  });

  function flitsGetProductDetailsFromWishlistResponse(handle){
    var item_details = undefined;
    Flits.each(window.flitswishlistResponse.data,function(index,item){
      if(item.product_handle == handle){
        item_details = item;
        return false;
      }
    });
    return item_details;
  }
  Flits(document).on('Flits:AddressDefault:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      Flits('.flits-address-card-action').removeClass('flits-disabled');
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  Flits(document).on('Flits:AddressSave:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  if(window.location.pathname == '/account'){
    Flits(document).on('click', '.my-account-logged-menu li a', function(event){
      event.preventDefault();
      var currentMenu = Flits(this).attr('rel');
      console.log(currentMenu)
      Flits('.flits-nav-tabs .flits-menu-item a[href="'+currentMenu+'"]').trigger('click');
    });
  }
  Flits(document).on('Flits:myProfile:Loaded', function(event){
  	let customer_detail_url = Flits.base_url + "/" + Flits.customer_id + "/profile_save";
    Flits.ajax({
      method: "get",
      url: customer_detail_url,
      data: {
        customer_hash: Flits.customerHash, token:Flits.token
      },
    }).done(function(resp){
      if(resp.customer.accepts_marketing == 1){
        Flits('#accepts_marketing').prop('checked', true);
        window.accept_marketing_flits = true;
      }
      else{
      	window.accept_marketing_flits = false;
      }
    });
  });
  Flits(document).on('Flits:myProfile:BeforeUpdate', function(event){
    var e_data =  event.detail.params;
    var acceptsMarketing;
    if (Flits('input#accepts_marketing').is(':checked')) {
      acceptsMarketing = 1;
    }
    else{
      acceptsMarketing = 0;
    }
    e_data.push({"name":"accepts_marketing","value":acceptsMarketing});
  });
  Flits(document).on('Flits:myProfile:Updated', function(event){
    if(event.detail.resp.customer.accepts_marketing == true){
      window.accept_marketing_flits = true;
    }
    else{
      window.accept_marketing_flits = false;
    }
  });
  Flits(document).on("click", ".flits-profile-cancel-button", function () {
    setTimeout(function(){
      if(window.accept_marketing_flits == true){
        Flits('#accepts_marketing').prop('checked', true);
      }
    }, 1000);
  });
  Flits.extend({
    redirectToCheckout: async function (parameters) {
      parameters = parameters || {};
      var form = Flits(Flits.StoreCreditCart.settings.checkoutFormSelectors.join(','));
      if (form.length <= 0) {
        // location.href = "/checkout?" + Flits.param(parameters);   
        location.href = location.origin+"/discount/"+parameters?.discount+"?redirect=/checkout";
        return true;
      }
      fetch(`/discount/${parameters?.discount}`)
        .then(function() {
            var form_action = form.attr("action");
            var form_action_data = Flits.parseURL(form_action);
      
            Flits.each(parameters, function (index, item) {
              var existing = form.find("[name='" + index + "']");
              if (existing.length <= 0) {
                form.append("<input type='hidden' name='" + index + "' value='" + item + "'>");
              } else {
                existing.val(item);
              }
              if (form_action_data.searchObject[index]) {
                form_action = form_action.replace(index + '=' + form_action_data.searchObject[index], item);
              } else {
                form_action += (form_action.indexOf('?') !== -1 ? "&" : "?") + index + "=" + item;
              }
            });
            form.append("<input type='hidden' name='checkout' value='true'>");
            form.attr("action", form_action);
            form.trigger('submit', [{ flitsFormSubmitted: true }]);
      });
    }
  })

  // Flits(document).on("Flits:StoreCreditCart:Loaded",function(event){
  //   debugger;
  //   let data = event.detail.settings;
  //   data.checkoutButtonSelectors.push(".mini-cart-wrapper .continue-btn");
  //   data.isCodeAutomatic = 1;
  // });

  Flits(document).on("Flits:CartAutomaticCode:Loaded",function(event){
    if(window.location.pathname != "/cart"){
      debugger
      let button_data = event.detail.cloneNode;
      setTimeout(function() {
        Flits(".continue-btn-wrapper").prepend(button_data);
      }, 2000);
    }
  });
  
}(Flits));
